import app from '@/api.js'

const state = {
    userData: null,
}

const getters = {
    isLogged: state => {
        return state.userData !== null && state.userData.idx;
    },
    isAdmin: state => {
        return state.userData !== null && state.userData.rules.admin;
    },
    company: state => {
        return state.userData !== null ? state.userData.companyName : "Anonymous";
    },
    name: state => {
        return state.userData !== null ? state.userData.name : "Anonymous";
    },
    sender: state => {
        try {
            return state.userData.settings.sender
        } catch (e) {
            return "Anonymous";
        }
    },
    tarif: state => {
        try {
            return state.userData.settings.tarif
        } catch (e) {
            return 0;
        }
    },
}
const actions = {
    LOGIN: async function (context, payload) {
        let vm = payload.__vm;
        payload.pars.password_ = vm.$CryptoJS.enc.Base64.stringify(vm.$CryptoJS.SHA256(payload.pars.password_));
        try {
            let result = await app.login(payload.pars);
            if (result.idx) {
                context.commit('setUser', result);
                return true;
            }
        } catch (e) {
            console.log(e);
        }
        context.commit('clearUser');
        throw vm.$t("error.login");
    },
    LOGOUT: async function (context) {
        try {
            await app.logout();
            context.commit('clearUser');
        } catch (e) {
            console.log(e);
        }
    }
}
const mutations = {
    setUser: (state, payload) => {
        try {
            if (payload.idx == undefined) {
                state.userData = null;
            } else {
                state.userData = payload;
            }
        } catch (e) {
            state.userData = null;
        }
    },
    clearUser: (state) => {
        state.userData = null;
    }
}

const User = {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}

export default User;